document.addEventListener("DOMContentLoaded", async function (event) {
    var totalMls = 0;
    var isCartEmpty = true;
    var hasGiftMessage = false;

    generateCartDisplay = function (cart) {
        let html = '';
        totalMls = 0;
        for (var i = 0; i <= cart.items.length - 1; i++) {
            if (window.constants.sampleProducts.includes(cart.items[i].id) ||
                window.constants.gwpArray.includes(cart.items[i].id) ||
                window.constants.giftMessage == cart.items[i].id) {
                continue;
            }

            let currentProduct = window.getProductCache(cart.items[i].product_id);
           
            vendor = cart.items[i].vendor;
            if (currentProduct) {
                title = currentProduct.nameTitle;
            } else {
                title = cart.items[i].title;
            }


            if (title.includes(" | ")) {
                title_html = `<span>`;
                title_html = title_html + title.replace(" | ", "</span><br><small>");
                title_html = title_html + `</small><br>`;
            } else {
                title_html = `<span>${cart.items[i].vendor}</span><br><small>${cart.items[i].title}</small><br>`;
            }

            html = html + `           <div class="dior-cart-item" id="lineitem-${i}">
                                        <div class="row">
                                            <div class="col-4 col-md-4">
                                                <a href="${cart.items[i].url}"><img src="${cart.items[i].image}" class="img-fluid mini-cart-img"></a>
                                            </div>
                                            <div class="col-5 col-md-5">
                                                <p style="font-weight: bold;">
                                                    ${title_html}
                                                    <small><a href="#!" style="text-decoration: underline;" onclick="window.removeMiniCartItem(${i + 1})" id="minicart-remove-${i + 1}">${window.theme.strings.mini_cart.remove}</a></small><br>
                                                    <small>$${(cart.items[i].line_price / 100).toFixed(0)}</small><br>
                                                    <small>
                                                    <input type="hidden" value="${cart.items[i].key}" class="product-id">
                                                    <input type="hidden" value="${cart.items[i].quantity}" class="qty">`;

            html = html + `
                                                </small></p>
                                            </div>
                                            <div class="col-3 col-md-3">
                                                <div class="row">Qty: <span class="qty">${cart.items[i].quantity}</span></div>

                                                <div class="row">`;

            if (cart.items[i].quantity < 3) {
                html = html + `<a href="#!" onclick="window.updateMiniCartQuantity(${cart.items[i].id}, ${cart.items[i].quantity + 1})" class="dior-cart-plus">+</a>`;
            }
            html = html + `<a href="#!" onclick="window.updateMiniCartQuantity(${cart.items[i].id}, ${cart.items[i].quantity - 1})" class="dior-cart-minus">-</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>`;
        }
        return html;
    }

    function generateSampleDisplay(cart) {
        let html = '';

        for (var i = 0; i <= cart.items.length - 1; i++) {
            if (window.constants.sampleProducts.includes(cart.items[i].id)) {
                html = html + `
                                                <div class="col-4 col-md-4">
                                                    <img src="${cart.items[i].image}" class="img-fluid mini-cart-img">
                                                    <p style="font-weight: bold;">
                                                        <small>${cart.items[i].title}</small><br>
                                                    </p>
                                                </div>`;
            }
        }

        return html;
    }

    function generateFreeGiftDisplay(cart) {
        let html = '';

        for (var i = 0; i <= cart.items.length - 1; i++) {
            if (window.constants.gwpArray.includes(cart.items[i].id)) {
                let title = '';

                let translations = JSON.parse(localStorage.getItem("translations"));

                if (window.theme.locale == "en" && translations && translations[cart.items[i].id]) {
                    title = translations[cart.items[i].id];
                } else {
                    title = cart.items[i].title;
                }

                html = html + `            <div class="dior-cart-item" id="lineitem-${i}">
                                            <div class="row">
                                                <div class="col-4 col-md-4">
                                                    <img src="${cart.items[i].image}" class="img-fluid mini-cart-img">
                                                </div>
                                                <div class="col-5 col-md-5">
                                                    <p style="font-weight: bold;">
                                                        <!-- <span>${cart.items[i].vendor}</span><br> -->
                                                        <small>${title}</small><br>
                                                        <small>FREE</small>
                                                    </p>
                                                </div>
                                                <div class="col-3 col-md-3">
                                                    <div class="row">Qty: <span> ${cart.items[i].quantity}</span></div>
                                                </div>
                                            </div>
                                          </div>`;
            }
        }

        return html;
    }


    window.resetMiniCartContents = function () {
        window.clearGiftMessage();
        $("#nav-cart-tab").html(window.theme.strings.mini_cart.title);
        $("#dior-cart-loading").show();
        $("#dior-cart-item-container").hide();
        $(".dior-cart-total").hide();
        $("#dior-cart-complete-order").html(window.theme.strings.mini_cart.loading);
        $("#dior-cart-loading-text").html(window.theme.strings.mini_cart.loading);
        $("#dior-cart-select-sample-button").hide();
        $("#dior-cart-sample-display").html("");
        $("#dior-cart-free-gift-display").html("");
        $(".rules").hide();
        $("#total-mls").hide();
        $("#dior-cart-gift-message-area").hide();
        $("#minicart-agree-area").hide();
        $("#minicart-please-agree").hide();
        $("#minicart-agree").prop("checked", false);
        $("#invalid-gift-message").hide();
        $("#invalid-lines").hide();
        $("#discount-code-area").hide();
        $("#expired-code").hide();
        $("#discount_").val("");
        $("#discount").val("");
        $("#invalid-price").hide();

        $("#code-stack-display").html("");
        $("#code-stack-display").hide();
    }

    window.updateMiniCartDisplay = async function (response) {
        // console.log("Cart ", response);
        if (response.item_count > 0) {
            isCartEmpty = false;
            let totalCount = response.item_count;
            let thePrice = await window.calcCartTotal(); //response.total_price;

            for (let i = 0; i <= response.items.length - 1; i++) {
                if (!window.constants.gwpArray.includes(response.items[i].id)) {
                    totalCount -= response.items[i].quantity;
                }

            }

            $("#dior-cart-item-container").html(generateCartDisplay(response));
            $("#dior-cart-total").html("Total $" + (thePrice / 100).toFixed(0));
            $(".dior-cart-total").show();
            $("#dior-cart-loading").hide();
            $("#dior-cart-item-container").fadeIn();
            $("#dior-cart-complete-order").html(window.theme.strings.mini_cart.complete_order_button);
            $(".dior-cart-complete-order").show();
            $(".dior-cart-minus").bind('click');
            $(".dior-cart-plus").bind('click');
            $("#dior-cart-select-sample-button").show();
            $("#dior-cart-sample-display").html(generateSampleDisplay(response));

            $("#nav-cart-tab").html(window.theme.strings.mini_cart.title + "(" + totalCount + ")");

            $("#dior-cart-free-gift-display").html(generateFreeGiftDisplay(response));

            $(".rules").show();
            $("#dior-cart-gift-message-area").show();
            $("#dior-minicart-loading").hide();
            $("#minicart-agree-area").show();

            $("#cart-count").html(totalCount);
            $("#cart-count").show();

            $("#invalid-price").hide();

            $("#discount-code-area").show();
            $("#discount-remove-area").hide();
            $("#discount-apply-area").show();

            if (localStorage.getItem("discount")) {
                $("#discount_").val(localStorage.getItem("discount"));
                $("#discount_").attr("disabled", true);
                $("#discount-apply-area").hide();
                $("#discount-remove-area").show();
            } else {
                $("#discount_").attr("disabled", false);
                $("#expired-code").hide();
            }

            // New code stack hide / show
            if (window.getCodeStack() !== []) {
                $("#code-stack-display").html(window.getCodeStackHtml());
                $("#code-stack-display").show();
            } else {
                $("#code-stack-display").html("");
                $("#code-stack-display").hide();
            }
        } else {
            isCartEmpty = true;
            $("#nav-cart-tab").html(window.theme.strings.mini_cart.title);
            $("#dior-cart-loading-text").html(window.theme.strings.mini_cart.empty_basket);
            $("#dior-cart-loading").show();
            $("#dior-cart-item-container").hide();
            $("#dior-cart-item-container").html('');
            $(".dior-cart-total").hide();
            $("#dior-cart-complete-order").html(window.theme.strings.mini_cart.continue_shopping);
            $("#dior-cart-select-sample-button").hide();
            $("#dior-cart-sample-display").html("");
            $("#dior-cart-free-gift-display").html("");
            $(".rules").hide();
            $("#minicart-agree-area").hide();
            $("#total-mls").hide();
            $("#dior-minicart-loading").hide();
            $("dior-cart-gift-message-area").hide();
            $("#minicart-agree").prop("checked", false);
            $("#minicart-please-agree").hide();
            $("#cart-count").html('');
            $("#cart-count").hide();
            $("#invalid-gift-message").hide();
            $("#invalid-lines").hide();
            $("#discount-code-area").hide();
            $("#discount-remove-area").hide();
            $("#discount-apply-area").show();
            $("#discount_").val("");
            $("#discount").val("");
            $("#expired-code").hide();
            $("#invalid-price").hide();
            window.clearGiftMessage();

            // new code stack on empty cart
            if (window.getCodeStack() !== []) {
                window.clearCodeStack();
            } 

            $("#code-stack-display").html("");
            $("#code-stack-display").hide();
        }
    }

    window.updateMiniCartQuantity = function (id, quantity) {
        $(".dior-cart-minus").unbind('click');
        $(".dior-cart-plus").unbind('click');
        $("#dior-minicart-loading").show();

        if (quantity <= 3) {
            window.updateItem(id.toString(), quantity).then(function () {
                window.refreshMiniCart();
            }).catch(function (response) {
                // console.log(response);
            });
        } else {
            window.refreshMiniCart();
        }

    }

    window.removeMiniCartItem = function (lineId) {
        $("#dior-minicart-loading").show();
        $(`#minicart-remove-${lineId}`).text(window.theme.strings.mini_cart.removing);
        $(`#minicart-remove-${lineId}`).unbind('click');
        window.removeItemByLine(lineId).then(function (response) {
            window.refreshMiniCart();
            // console.log(response);
        }).finally(function () {
            $(`#minicart-remove-${lineId}`).bind('click');
        });
    }

    window.refreshMiniCart = function () {
        $("#dior-minicart-loading").show();
        window.getCart().then(function (response) {
            window.resetMiniCartContents();
            window.updateMiniCartDisplay(response);
        }).catch(function (response) {
            console.log(response);
            $("#dior-cart-complete-order").hide();
            $("#dior-cart-loading-text").html("There was an error loading the cart.");
        });

        if (localStorage.getItem("discount") !== null) {
            $("#discount_").val(localStorage.getItem("discount"));
            $("#discount_").attr("disabled", true);
            $("#discount-apply-area").hide();
            $("#discount-remove-area").show();
        }
    }

    window.showMiniCart = function () {
        $("#dior-minicart-loading").show();
        window.resetMiniCartContents();
        $('body').css("overflow-y", "hidden");
        $("#dior-minicart").fadeIn();
        window.getCart().then(function (response) {
            window.updateMiniCartDisplay(response);
            window.updateCartCache(response);
        }).catch(function (response) {
            console.log(response);
            $("#dior-cart-complete-order").hide();
            $("#dior-cart-loading-text").html("There was an error loading the cart.");
        });


    }

    window.hideMiniCart = function () {
        $("#dior-minicart").fadeOut();
        $('body').css("overflow-y", "scroll");
    }

    if (localStorage.getItem("gift_message_added") && !localStorage.getItem("gift_message")) {
        localStorage.removeItem("gift_message");
        localStorage.removeItem("gift_message_added");
    }
    window.clearGiftMessage = function () {
        if ($("#dior-cart-gift-message").val() === "") {
            localStorage.removeItem("gift_message");
            localStorage.removeItem("gift_message_added");
        }

        if (localStorage.getItem("gift_message_added") && !localStorage.getItem("gift_message")) {
            localStorage.removeItem("gift_message");
            localStorage.removeItem("gift_message_added");
        }
    }

    $("#discount_remove").on("click", async function (e) {
        $("#dior-cart-loading").show();
        $(this).attr("disabled", true);

        let showArea = false;

        if (localStorage.getItem("discount_data") === null) { // !== null && localStorage.getItem("discount_data").length > 0
            var discountData = await window.checkDiscountGwp($("#discount_").val());
        } else {
            var discountData = JSON.parse(localStorage.getItem("discount_data"));
        }

        if (discountData) {
            // console.log("discountData", discountData);

            for (let i = 0; i < discountData.length; i++) {
                // Add products
                await window.updateItem(discountData[i].toString(), 0, {}).then(function () {
                    // console.log("remove discount item " + i);
                });
            }

            showArea = true;
            window.removeCodeStack($("#discount_").val());
            localStorage.removeItem("discount_data");
            localStorage.removeItem("discount");

            
        }

        if (showArea) {
            $("#discount_").attr("disabled", true);
            $("#discount-apply-area").hide();
            $("#discount-remove-area").show();
        } else {
            $("#discount_").attr("disabled", false);
            $("#discount_").val("");
            $("#discount").val("");
            $("#discount-apply-area").show();
            $("#discount-remove-area").hide();
        }

        refreshMiniCart();

        $(this).attr("disabled", false);

    });

    // var codeStack = [];
    // if (localStorage.getItem("codeStack") !== null) {
    //     codeStack = JSON.parse(localStorage.getItem("codeStack"));
    // }
    
    $("#discount_apply").on("click", async function (e) {
        if ($("#discount_").val().length)
        {
            $("#dior-cart-loading").show();

            $(this).attr("disabled", true);
            $("#discount_").attr("disabled", true);

            // console.log($("#discount_").val());

            let showArea = true;
            let codeStack = window.getCodeStack();

                if ($("#discount_").val() !== "") {
                    $("#invalid-discount").hide();
                    $("#expired-code").hide();

                    let ids = [];
                    let cart = window.getCartCache();

                    // Check if code is already added
                    if (window.hasCodeStack($("#discount_").val())) {
                        $("#discount_").attr("disabled", false);
                        $("#discount_apply").attr("disabled", false);
                        $("#discount-apply-area").show();
                        $("#discount-remove-area").hide();
                        $("#invalid-discount").show();
                        e.preventDefault();
                        return false;
                    }
                    

                    // Generate cart PRODUCT ids to be checked on discounts.php
                    if (cart.items) {
                        for (let i = 0; i <= cart.items.length - 1; i++) {
                            if (cart.items[i].product_id && !window.constants.gwpArray.includes(cart.items[i].id)) {
                                for (let j = 0; j <= cart.items[i].quantity - 1; j++) {
                                    ids.push(cart.items[i].product_id);
                                }
                            }
                        }
                    }

                    let check = await window.checkDiscountGwp($("#discount_").val(), ids);

                    if (check === false) {
                        // Not valid
                        // console.log("Invalid coupon code");
                        $("#invalid-discount").show();
                        $("#dior-cart-loading").hide();

                        localStorage.removeItem("discount_data");
                        localStorage.removeItem("discount");

                        $("#discount_").attr("disabled", false);
                        $("#discount_apply").attr("disabled", false);
                        $("#discount-apply-area").show();
                        $("#discount-remove-area").hide();

                        return false;
                    } else if (check === true) {
                        $("#discount").val($("#discount_").val());
                        localStorage.setItem("discount", $("#discount_").val());
                        window.setCodeStack($("#discount_").val().toUpperCase());
                        $("#dior-cart-loading").hide();
                        showArea = false;
                    } else if (check.length && !check.error && !window.hasCodeStack($("#discount_").val().toUpperCase())) {
                        // console.log("Got some product IDs");
                        let theCode = $("#discount_").val().toUpperCase();
                        showArea = true;
                        // console.log("trying", theCode, codeStack);

                        for (let i = 0; i < check.length; i++) {
                            // Add products
                            await window.addToCart(check[i].toString(), 1).then(function (response) {
                                if (!window.hasCodeStack(theCode)) {
                                    window.setCodeStack(theCode);
                                }

                                console.log(`Added code ${theCode}`, response);
                            });
                        }

                        console.log("code stack end ", window.getCodeStack());
                        refreshMiniCart();                      


                    } else if (check.length && check.error) {
                            window.removeCodeStack($("#discount_").val().toUpperCase());
                            $("#expired-code").show();
                            $("#dior-cart-loading").hide();
                            // break;

                    } else if (check.error && check.error === "You need to add more products to be eligible for this code.") {
                        localStorage.removeItem("discount_data");
                        localStorage.removeItem("discount");
                        window.removeCodeStack($("#discount_").val().toUpperCase());
                        $("#invalid-price").show();
                        $("#dior-cart-loading").hide();
                    } else if (check.error && check.error === "Code has expired.") {
                        // console.log("Expired code");
                        $("#expired-code").show();

                        localStorage.removeItem("discount_data");
                        localStorage.removeItem("discount");
                        window.removeCodeStack($("#discount_").val().toUpperCase());
                        $("#dior-cart-loading").hide();
                    }

                    if (!showArea) {
                        $("#discount_").attr("disabled", true);
                        $("#discount-apply-area").hide();
                        $("#discount-remove-area").show();
                    } else {
                        $("#discount_").attr("disabled", false);
                        $("#discount-apply-area").show();
                        $("#discount-remove-area").hide();
                    }
                }

                

                $(this).attr("disabled", false);
        }
    });


    var secondRun = false;

    $("#checkout-link").on("click", async function (e) {
        var agreed = $("#minicart-agree").prop("checked");
        const WAVE_FLAG = 'wc-pickup-options-suppress';

        window[WAVE_FLAG] = true;

        if (secondRun) {
            delete window[WAVE_FLAG];
        }
        
        if (!window.theme.loggedin && agreed && !secondRun) {
            e.preventDefault();
            window.location = (window.theme.locale === "en" ? "/en" : "") + "/account/login?return_url=%2F%3Fshowcart%3D1%3Fcache%3Dfalse";
            return false;
        }

        if (!isCartEmpty && !agreed && !secondRun) {
            $("#dior-minicart-loading").hide();
            $("#minicart-please-agree").show();

            e.preventDefault();
            return false;

        }

        let giftMessage = $("#dior-cart-gift-message").val();

        if (giftMessage.length ) {

            const REGEX_CHINESE = /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;
            const hasChinese = (str) => REGEX_CHINESE.test(str);

            lines = giftMessage.split(/\r\n|\r|\n/);
            if (lines.length > 6) {
                $("#invalid-lines").show();
                $("#dior-minicart-loading").hide();
                e.preventDefault();
                return false;
            }

            if (lines.length) {
                for (let i = 0; i <= lines.length - 1; i++) {
                    if (lines[i].length > (hasChinese ? 25 : 50)) {
                        $("#invalid-lines").show();
                        $("#dior-minicart-loading").hide();
                        e.preventDefault();
                        return false;
                    }
                }
            }

            let emojiTest = new RegExp("(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])");
            let symbolTest = new RegExp(/[^\u0000-\u007F]+/g);
            let semiColon = new RegExp(/;/g);

            if (symbolTest.test(giftMessage) || emojiTest.test(giftMessage) || semiColon.test(giftMessage)) {
                $("#invalid-gift-message").show();
                $("#divLocalpickup").hide();
                $("#dior-minicart-loading").hide();
                e.preventDefault();
                return false;
            }

        }

        var hasGift = false;
        var hasMaisonGift = false;
        var giftKey = null;
        var cart = window.getCartCache();
        var maison = false;
        var giftIdToAdd = null;

        $("#dior-minicart-loading").show();
        $(window).scrollTop(0);

        if (!secondRun) {

            e.preventDefault();

            await window.getCart().then(function (response) {
                cart = response;

                if (!isCartEmpty && agreed && cart.items.length) { 

                    for (var i = 0; i <= cart.items.length - 1; i++) {
                        if (window.constants.giftMessage === cart.items[i].id) {
                            hasGift = true;
                            giftKey = cart.items[i].key;
                        }

                        if (window.constants.giftMessageMaison === cart.items[i].id) {
                            hasMaisonGift = true;
                            giftKey = cart.items[i].key;
                        }

                        if (cart.items[i].vendor === "Maison Christian Dior") {
                            maison = true;
                        }

                    }

                    $(this).prop('disabled', false);

                    if ($("#divLocalpickup").is(':visible')) {
                        localStorage.removeItem("cart");
                    }

                    $("#discount").val($("#discount_").val());
                    $("#dior-cart-loading").hide();

                    return false;
                } else if (isCartEmpty) {
                    $("#dior-minicart-loading").hide();
                    window.hideMiniCart();
                }

            }).finally(function () {
                $("#dior-minicart-loading").hide();
                secondRun = true;
                $("#dior-cart-loading").hide();
                $("#checkout-link").click();
            });

        } 

    });

    var maxLength = 50;
    $('#dior-cart-gift-message').on('input focus keydown keyup', function (e) {
        var text = $(this).val();
        var lines = text.split(/(\r\n|\n|\r)/gm);
        var check = text.split(/\r\n|\r|\n/);

        if (check.length <= 6) {

            if (check.length < 6) {
                $("#invalid-lines").hide();
            }

            for (var i = 0; i < lines.length; i++) {
                if (lines[i].length > maxLength) {
                    lines[i] = lines[i].substring(0, maxLength) + '\n';
                }
            }
            $(this).val(lines.join(''));
        } else {
            $(this).val( $(this).val().substring(0, $(this).val().length - 1, $(this).val()) );
            $("#invalid-lines").show();
        }

        localStorage.setItem("gift_message", $(this).val());

        $("#gift-message-char-limit").html(280 - $(this).val().length);
    });


    if (localStorage.getItem("gift_message") !== null) {
        $("#dior-cart-gift-message").val(localStorage.getItem("gift_message"));

        $("#gift-message-char-limit").html(280 - $("#dior-cart-gift-message").val().length);
    }

    if (document.URL.match(/showcart=([0-9]+)/) && document.URL.match(/showcart=([0-9]+)/)[1]) {
        window.showMiniCart();
    }

}); 
